
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"d":"M7.06 9.22a3.6 3.6 0 0 0 4.14 1.218 3.6 3.6 0 0 0 1.288-.828l2.16-2.162a3.605 3.605 0 0 0-2.558-6.106 3.597 3.597 0 0 0-2.532 1.011L8.32 3.586m1.62 4.193A3.6 3.6 0 0 0 5.8 6.562c-.484.18-.923.463-1.288.828l-2.16 2.162a3.605 3.605 0 0 0 2.558 6.106 3.597 3.597 0 0 0 2.532-1.011l1.23-1.233","stroke":"#798f8f","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    